export const DATA_ACCESS_REQUEST_APPROVAL_MODAL_TITLE = 'Approve data access request?'

export const DATA_ACCESS_REQUEST_APPROVAL_MODAL_APPROVE_LABEL = 'Yes, approve'

export const DATA_ACCESS_REQUEST_AUTOMATIONS_SECTION_TITLE = 'Automations'

export const DATA_ACCESS_REQUEST_AUTOMATIONS_SECTION_DESCRIPTION =
  'Enter a study ID that will be used to match against the workspace that already exists or future workspaces, and this data access request will be automatically shared with the workspace.'

export const DATA_ACCESS_REQUEST_STUDY_ID_INPUT_LABEL = 'Workspace study ID'

export const DATA_ACCESS_REQUEST_STUDY_ID_INPUT_PLACEHOLDER = 'Enter workspace study ID'

export const DATA_ACCESS_REQUEST_STUDY_ID_IMMUTABLE_WARNING =
  'Study ID cannot be changed after approval. Review it carefully before approving.'

export const DATA_ACCESS_REQUEST_STUDY_ID_MATCHED_ALERT =
  'The study ID already exists. When you approve this request, this data source will be automatically shared with the workspace.'

export const DATA_ACCESS_REQUEST_STUDY_ID_UNMATCHED_ALERT =
  'No matching workspace yet. You can approve this request, but the data will remain unshared until a workspace is assigned to this Study ID.'

export const DATA_ACCESS_REQUEST_STUDY_ID_VALIDATION_ERROR =
  "We couldn't check for a matching workspace. Check your connection and try again."

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_MODAL_TITLE = 'Request additional information?'

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_MODAL_OK_LABEL = 'Request additional information'

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_MODAL_DESCRIPTION =
  'The request will be rejected and the requester will be notified to complete the additional information form. Enter a reason specifying the information needed; it will be visible to the requester and other Airlock Managers.'

export const DATA_ACCESS_REQUEST_FORM_TITLE = 'Data access request'

export const DATA_ACCESS_REQUEST_ORIGINAL_FORM_TITLE = 'Original data access request form'

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_FORM_TITLE = 'Additional information request form'

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_METADATA_TEST_ID =
  'data-access-request-additional-information-metadata'

export const DATA_ACCESS_REQUEST_LINKED_CHILD_ALERT_TEST_ID = 'data-access-request-linked-child-alert'

export const DATA_ACCESS_REQUEST_ADDITIONAL_INFORMATION_FORM_VIEW_ACTION_TEST_ID =
  'additional-information-form-view-action'

export const DATA_ACCESS_REQUEST_PERSON_ID_FILE_CARD_TEST_ID = 'data-access-request-person-id-file-card'

export const DATA_ACCESS_REQUEST_APPROVAL_CONFIGURATION_ERROR_ALERT =
  "We couldn't load the requester workspace configuration, so this request cannot be approved right now. Refresh the page to try again. You can still reject the request or request additional information."

export const DATA_ACCESS_REQUEST_APPROVAL_CONFIGURATION_ERROR_ALERT_TEST_ID =
  'data-access-request-approval-configuration-error-alert'
